import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../../mutation-types';
import CrmTrackingsAPI from '../../../api/crm/trackings';

export const state = {
    records: [],
    uiFlags: {
        isFetching: false,
        isCreating: false,
        isUpdating: false,
        isDeleting: false,
    },
};

export const getters = {
    getUIFlags(_state) {
        return _state.uiFlags;
    },
    getTrackings(_state) {
        return _state.records;
    },
    getTrackingById: _state => id => {
        return _state.records.find(r => r.id === Number(id));
    },
};

export const actions = {
    get: async ({ commit }) => {
        commit(types.SET_CRM_TRACKINGS_UI_FLAG, { isFetching: true });
        try {
            const response = await CrmTrackingsAPI.get();
            commit(types.SET_CRM_TRACKINGS, response.data);
        } catch (error) {
            // Ignore error
        } finally {
            commit(types.SET_CRM_TRACKINGS_UI_FLAG, { isFetching: false });
        }
    },
    create: async ({ commit }, trackingObj) => {
        commit(types.SET_CRM_TRACKINGS_UI_FLAG, { isCreating: true });
        try {
            const response = await CrmTrackingsAPI.create(trackingObj);
            commit(types.ADD_CRM_TRACKING, response.data);
            return response.data;
        } catch (error) {
            throw new Error(error);
        } finally {
            commit(types.SET_CRM_TRACKINGS_UI_FLAG, { isCreating: false });
        }
    },
    update: async ({ commit }, { id, ...updateObj }) => {
        commit(types.SET_CRM_TRACKINGS_UI_FLAG, { isUpdating: true });
        try {
            const response = await CrmTrackingsAPI.update(id, updateObj);
            commit(types.EDIT_CRM_TRACKING, response.data);
        } catch (error) {
            throw new Error(error);
        } finally {
            commit(types.SET_CRM_TRACKINGS_UI_FLAG, { isUpdating: false });
        }
    },
    delete: async ({ commit }, id) => {
        commit(types.SET_CRM_TRACKINGS_UI_FLAG, { isDeleting: true });
        try {
            await CrmTrackingsAPI.delete(id);
            commit(types.DELETE_CRM_TRACKING, id);
        } catch (error) {
            throw new Error(error);
        } finally {
            commit(types.SET_CRM_TRACKINGS_UI_FLAG, { isDeleting: false });
        }
    },
};

export const mutations = {
    [types.SET_CRM_TRACKINGS_UI_FLAG](_state, data) {
        _state.uiFlags = { ..._state.uiFlags, ...data };
    },
    [types.SET_CRM_TRACKINGS]: MutationHelpers.set,
    [types.ADD_CRM_TRACKING]: MutationHelpers.create,
    [types.EDIT_CRM_TRACKING]: MutationHelpers.update,
    [types.DELETE_CRM_TRACKING]: MutationHelpers.destroy,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
